export default function getNonce() {
  return (document.querySelector('meta[property=csp-nonce]') as any)?.nonce;
}
